import React, { Component } from 'react'

import ReactHighmaps from 'react-highcharts/ReactHighmaps.src'
import HomeMapAdapter from './HomeMapAdapter'
import HomeMapConfig from './HomeMapConfig'

import APPURL from 'utils/app/urls'

import Loading from 'components/Loading'
import Error from 'components/Error'

class HomeMap extends Component {
  constructor(props) {
    super(props)

    this.state = {
      loading: true,
      error: false
    }
  }

  componentDidMount() {
    let chartConfig = HomeMapConfig.generalConfig

    let series = HomeMapAdapter.formatMapSeries({ regionsData: this.props.regionsData, fn: this.changeRegion })
    chartConfig.series = series
    this.setState({ chartConfig, loading: false, error: false })
  }

	changeRegion = region => {
	  const selectedCode = region.code
	  let oldURL = this.props.history.location.pathname
	  let newURL = APPURL.getSameURLWithChangedRegion({ url: oldURL, regionCode: selectedCode })
	  if (oldURL !== newURL) {
	    this.props.history.push(newURL)
	  }

	  this.props.setSelectedRegionId(region.id)
	}

	renderIfAllOK() {
	  if (this.state.error) {
	    return <Error />
	  } else if (this.state.loading) {
	    return <Loading />
	  } else {
	    return <ReactHighmaps ref={this.mapChart} config={this.state.chartConfig} />
	  }
	}

	render() {
	  return <React.Fragment>{this.renderIfAllOK()}</React.Fragment>
	}
}

export default HomeMap



// WEBPACK FOOTER //
// ./src/modules/Charts/Map/HomeMap/HomeMap.jsx